import BaseRepository from '@/baseRepository/BaseRepository';
const resource = `/api/v1/rawmaterials`;



export default {

getRawMaterial(baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.get(`${resource}`, {
      baseURL,
      headers,
      params
    });
  },
}